module.exports = __webpack_public_path__ + "static/img/672_phase_function_Paper_Points.251c118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/672_phase_function_Paper_Points.png
// module id = aiqt
// module chunks = 0